import React from "react";
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import clock from '../../Assets/clock-icon.svg'
import service from '../../Assets/service-icon.svg'
import rating from '../../Assets/rating-icon.svg'

export function Services() {
    return (
    <Container fluid='xl' style={{minHeight : '50vh'}} className='my-3'>
        <h4 className="my-3 text-light text-center">Layanan Kami</h4>
        <div className="d-flex justify-content-around flex-wrap">
            <Card style={{ width: '18rem' }} className='text-center m-2'>
            <Card.Body>
                <Card.Img variant="top" src={clock} />
                <Card.Title>Hemat Waktu</Card.Title>
                <Card.Text>
                    Sewa mobil cukup di genggaman Anda, kapan saja dan di mana saja.
                </Card.Text>
            </Card.Body>
            </Card>
            <Card style={{ width: '18rem' }} className='text-center m-2'>
            <Card.Body>
                <Card.Img variant="top" src={service} />
                <Card.Title>Servis Berkualitas Dari Partner Tepercaya</Card.Title>
                <Card.Text>
                    Rental Mobil Three Brothers menyediakan service berkualitas demi kenyamanan perjalanan anda.
                </Card.Text>
            </Card.Body>
            </Card>
            <Card style={{ width: '18rem' }} className='text-center m-2'>
            <Card.Body>
                <Card.Img variant="top" src={rating} />
                <Card.Title>Rating Pengguna Asli</Card.Title>
                <Card.Text>
                    Pastikan Kepercayaan anda kepada kami. Rating dari pengguna lain akan meningkatkan kepercayaan anda untuk memilih mobil rental melalui pelayanan kami.
                </Card.Text>
            </Card.Body>
            </Card>
        </div>
    </Container>
    )
}